import { AccordionFieldsFragment, AccordionItemFieldsFragment } from '@src/generated/graphql';
import { Accordion } from 'src/components/shared';

type StreamLineProps = {
  content: AccordionFieldsFragment;
};

const StreamLineComponent = ({ content }: StreamLineProps) => {
  const { accordionItemsCollection, descriptionJson, image } = content;
  const items = accordionItemsCollection?.items || [];

  const renderContent = (content: any) => {
    return content.map((item: any, index: number) => {
      if (item.nodeType === 'text') {
        return (
          <h2 className="header-2 mb-0 text-black" style={{maxWidth: 'calc(12ch)'}} key={index}>
            {item.value}
          </h2>
        );
      }

      return null;
    });
  };

  return (
    <section>
      <div className="box-corner-content ps-0 pe-0 pt-sm-60 pt-md-100 pb-md-120">
        <div className="container-fluid custom-spacer-col">
          <section className="box-bg-wrap">
            <div className="box-bg-content-left">
              <div className="box-bg-content box-bg-img-left">
                {renderContent(descriptionJson?.json?.content?.[0]?.content)}
               
              </div>
            </div>
            <div className="box-bg-img-right">
              <div className="accordion-component-block text-black">
                  <Accordion items={items as AccordionItemFieldsFragment[]} />
                </div>
           
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default StreamLineComponent;
